module.exports = __webpack_public_path__ + "static/img/maisheng.15ffb46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/maisheng.jpg
// module id = h1eW
// module chunks = 0